module.exports = __webpack_public_path__ + "static/media/Large_2018.7a4cef55.svg";